"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CookieSetting", {
  enumerable: true,
  get: function () {
    return _CookieSetting.default;
  }
});
var _CookieSetting = _interopRequireDefault(require("./CookieSetting"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }